import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { AccountInfo } from "@azure/msal-browser";

@Injectable({ providedIn: "root" })
export class AzureAccountService {
	constructor(private msalService: MsalService) {}

	getPreferred(loginHint: string | null): AccountInfo | null {
		const normalizedHint = this.normalizeLoginHint(loginHint);
		const accounts = this.msalService.instance.getAllAccounts();

		if (normalizedHint) {
			return (
				accounts.find((account) =>
					this.matchesLoginHint(account, normalizedHint)
				) || null
			);
		}

		return (
			this.msalService.instance.getActiveAccount() ||
			(accounts.length === 1 ? accounts[0] : null)
		);
	}

	getCurrent(): AccountInfo | null {
		return (
			this.msalService.instance.getActiveAccount() ||
			this.getPreferred(null)
		);
	}

	setActive(account: AccountInfo | null): void {
		this.msalService.instance.setActiveAccount(account);
	}

	getLoginHint(account: AccountInfo | null): string | null {
		if (!account) {
			return null;
		}

		const claims = account.idTokenClaims as any;
		return this.normalizeLoginHint(
			claims?.preferred_username ||
				claims?.unique_name ||
				account.username ||
				null
		);
	}

	matchesLoginHint(account: AccountInfo, loginHint: string): boolean {
		return this.getLoginHint(account) === this.normalizeLoginHint(loginHint);
	}

	hasAmbiguousAccounts(): boolean {
		return (
			!this.msalService.instance.getActiveAccount() &&
			this.msalService.instance.getAllAccounts().length > 1
		);
	}

	normalizeLoginHint(value: string | null): string | null {
		const normalized = value?.trim().toLowerCase();
		return normalized || null;
	}
}
